import React from 'react';
import Link from 'gatsby-link';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import Popover from '@marvelapp/marvel-ui/popover';

import ArrowDown from 'marketing-website/components/icons/ArrowDown';
import Image from 'marketing-website/components/modules/Image';
import VerticalLine from 'marketing-website/components/modules/VerticalLine';

import NavDropdownColumn from './NavDropdownColumn';
import NavDropdownFooter from './NavDropdownFooter';

import desktopStyles from './style/desktop.module.css';
import mobileStyles from './style/mobile.module.css';

const cx = classNames.bind({ ...mobileStyles });

export default function NavDropdown({
  firstColumnHeading,
  firstColumnItems,
  isLight,
  linkType,
  title,
  secondColumnHeading,
  secondColumnItems,
  secondSubColumnHeading,
  secondSubColumnItems,
  size,
  url,
  ...item
}) {
  const dropdownClasses = cx(desktopStyles.dropdown, {
    [desktopStyles.dark]: !isLight,
    [desktopStyles.light]: isLight,
  });

  return (
    <Popover
      position="bottom"
      showOnHover
      width="min-content"
      hasAnimation={false}
    >
      <Popover.Trigger>
        <div className={dropdownClasses}>
          <div className={desktopStyles.navTitle}>{title}</div>
          <ArrowDown />
        </div>
      </Popover.Trigger>
      <Popover.Content>
        <div className={desktopStyles.tabContainer}>
          <div className={desktopStyles.contentInner}>
            {item.image && (
              <Link to={item.image.url}>
                <div className={desktopStyles.imageColumn}>
                  <Image
                    alt={item.image.alt}
                    src={item.image.src}
                    maxWidth={264}
                    hasShadow={false}
                  />
                </div>
              </Link>
            )}
            <div className={item.image && `marginLeft-s`}>
              <NavDropdownColumn
                listItems={firstColumnItems}
                colHeading={firstColumnHeading}
                size={size}
              />
            </div>
            {secondColumnItems && (
              <div className="display-flex">
                <VerticalLine />
                <div className="marginLeft-s">
                  <NavDropdownColumn
                    listItems={secondColumnItems}
                    colHeading={secondColumnHeading}
                    size={size}
                  />
                  {secondSubColumnItems && (
                    <div className="paddingTop-xxs paddingBottom-xs">
                      <NavDropdownColumn
                        listItems={secondSubColumnItems}
                        colHeading={secondSubColumnHeading}
                        size={size}
                      />
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
          {item.footer && (
            <NavDropdownFooter url={item.footer.url}>
              {item.footer.description}
            </NavDropdownFooter>
          )}
        </div>
      </Popover.Content>
    </Popover>
  );
}

NavDropdown.propTypes = {
  firstColumnHeading: PropTypes.string.isRequired,
  firstColumnItems: PropTypes.array,
  isLight: PropTypes.bool.isRequired,
  linkType: PropTypes.string,
  title: PropTypes.string.isRequired,
  secondColumnHeading: PropTypes.string.isRequired,
  secondColumnItems: PropTypes.array,
  size: PropTypes.string,
  url: PropTypes.string.isRequired,
  secondSubColumnHeading: PropTypes.string,
  secondSubColumnItems: PropTypes.array,
};



// WEBPACK FOOTER //
// ./src/components/modules/Header/HeaderNav/NavDropdown.js